export const getTradingDaily = (state) => state.trading.daily.data;

export const getTradingHst = (state) => state.trading.history.data;

export const getTradingDailyStockExchange = (state) =>
  state.trading.dailyStockExchange.data;

export const getTradingHstStockExchange = (state) =>
  state.trading.historyStockExchange.data;

export const getTradingDailyFunds = (state) => state.trading.dailyFunds.data;

export const getTradingHstFunds = (state) => state.trading.historyFunds.data;

export const getSelectedTrade = (state) => state.trading.selectedTrade;

export const getIsLoadingTradingDaily = (state) =>
  state.trading.daily.isLoading;

export const getIsLoadingTradingHst = (state) =>
  state.trading.history.isLoading;

export const getIsLoadingTradingDailyStockExchange = (state) =>
  state.trading.dailyStockExchange.isLoading;

export const getIsLoadingTradingHstStockExchange = (state) =>
  state.trading.historyStockExchange.isLoading;

export const getIsLoadingTradingDailyFunds = (state) =>
  state.trading.dailyFunds.isLoading;

export const getIsLoadingTradingHstFunds = (state) =>
  state.trading.historyFunds.isLoading;

export const getCurrentTradingTab = (state) => state.trading.currentTab;
